import React from 'react';
import { Timeline } from 'antd';
import { Link } from 'dva/router';
import classNames from 'classnames';
import ABSDotIcon from './components/ABSDot';
import './AnchorPoint.less';

export interface IAnchorPointItem {
  title: string;
  href: string;
  active?: boolean;
}

export interface IAnchorPointProps {
  anchorPointItems: Array<IAnchorPointItem>;
  onClick: (e: any, index: number) => void;
  height?: number;
  width?: number;
  right?: number;
  style?: any;
  id?: string;
  isStaticHide?: boolean; // 是否静止一段时间隐藏锚点框
}

export interface IAnchorPointState {
  href: string;
}

class AnchorPoint extends React.Component<IAnchorPointProps, IAnchorPointState > {

  renderActiveAnchorPointItem(anchorPointItem: IAnchorPointItem, index: number) {
    const { onClick } = this.props;
    const { href, title } = anchorPointItem;

    return (
      <Timeline.Item
        className="timeline"
        key={`${href}${title}`} 
        dot={<ABSDotIcon />}
      >
        <Link className="link-timeline-check" to={href} onClick={(e: any) => onClick(e, index)}>{title}</Link >
      </Timeline.Item>
    );
  }

  renderNormalAnchorPointItem(anchorPointItem: IAnchorPointItem, index: number) {
    const { onClick } = this.props;
    const { href, title } = anchorPointItem;
    return (
      <Timeline.Item key={`${href}${title}`} className="timeline">
        <Link 
          to={href} 
          className="link-timeline"
          onClick={(e: any) => onClick(e, index)}
        >
          {anchorPointItem.title}
        </Link >
      </Timeline.Item>
    );
  }

  renderList() {
    const { anchorPointItems } = this.props;
    if (anchorPointItems && anchorPointItems.length > 0) {
      return anchorPointItems.map((item, index) => {
        if (item.active) {
          return this.renderActiveAnchorPointItem(item, index);
        }
        return this.renderNormalAnchorPointItem(item, index);
      });
    }
    
    return null;
  }

  render() {
    const { width = 145, height = '100%', right = 13, style, id, isStaticHide} = this.props;
    const classes = classNames('abs-anchor-point', {'abs-anchor-point-static-hide': isStaticHide});
    return (
      <div 
        id={id}
        className={classes} 
        style={{ width: width, height: height, right: right, ...style }}
      >
        <Timeline >
          {this.renderList()}
        </Timeline>
      </div>
    );
  }
}

export default AnchorPoint;  


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSAnchorPoint/AnchorPoint.tsx